var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPeriod(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 28,
    viewBox: "0 0 25 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.2217 2.79999H20.8328V0H18.0551V2.79999H6.9444V0H4.16664V2.79999H2.77776C1.23611 2.79999 0.0139561 4.06013 0.0139561 5.59997L0 25.2C0 26.7399 1.23618 28 2.77776 28H22.2222C23.7499 28 25 26.7399 25 25.2L24.9997 5.59997C24.9997 4.06006 23.7496 2.79999 22.222 2.79999H22.2217ZM22.2217 25.1997H2.77723V11.1998H22.2217V25.1997ZM22.2217 8.39942L2.77723 8.39968V5.5997H22.2217V8.39968V8.39942ZM12.4991 15.3994H19.4435V22.3994H12.4991V15.3994Z",
    fill: "#001EFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeriod);
export default __webpack_public_path__ + "static/media/period.c3010a0e8f74d833e4dd66af5e5f20a7.svg";
export { ForwardRef as ReactComponent };